import {
  IAppConfigurationProvider
} from '@dirootie-core/core-types';
import { ConsoleLogger } from '@dirootie-logging/logging';
import { ILogger } from '@dirootie-logging/logging-types';
import { ReactToastifyUserNotificationService } from '@components-common/notifications';
import {
  navigatorOptionsDefaults,
} from '@dirootie-web/web-apps-types';
import { createServiceProvider } from './service.provider';
import { IAppModule, IServiceProvider } from './modules.types';
import { MainAppViewStore } from '../MainAppViewStore';
import { ViewNavigator } from '../ViewNavigator';

export class CoreModule {
  serviceProvider: IServiceProvider;
  logger: ILogger;

  constructor() {
    this.serviceProvider = createServiceProvider();
    this.logger = new ConsoleLogger({level:'TRACE',provider:"console"}, {
      id: 'id',
      provider: 'console',
      category: 'logger',
      properties: {},
    });
    this.serviceProvider.register('logger', this.logger);
  }
  name = 'core';

  getServiceProvider() {
    return this.serviceProvider;
  }

  configureServices(
    serviceProvider: IServiceProvider,
    configurationProvider: IAppConfigurationProvider
  ): void {
    const notificationService = new ReactToastifyUserNotificationService(this.logger);
    serviceProvider.register('user-notification-service', notificationService);
    const navigator = new ViewNavigator(navigatorOptionsDefaults);
    serviceProvider.register('navigator', navigator);
    serviceProvider.register('main-view-store', new MainAppViewStore(this.logger as any));
  }
}
